import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Card, CardContent, Divider, Grid, IconButton, LinearProgress, Stack, Typography, } from "@mui/material";
import { Link } from "react-router-dom";
const getColorForValue = (value) => {
    if (value >= 80)
        return "#2e7d32";
    if (value >= 60)
        return "#558b2f";
    if (value >= 40)
        return "#f9a825";
    if (value >= 20)
        return "#ef6c00";
    return "#c62828";
};
export const PlayerStatsCard = ({ player, canModify, }) => {
    const attributes = [
        { label: "Heading", value: player.heading },
        { label: "Passing", value: player.passing },
        { label: "Positioning", value: player.positioning },
        { label: "Defending", value: player.defending },
        { label: "Finishing", value: player.finishing },
        { label: "Dribbling", value: player.dribbling },
        { label: "Shooting", value: player.shooting },
        { label: "Tackling", value: player.tackling },
        { label: "Crossing", value: player.crossing },
        { label: "Leadership", value: player.leadership },
        { label: "Communication", value: player.communication },
        { label: "Speed", value: player.speed },
        { label: "Fitness", value: player.fitness },
        { label: "Goalkeeping", value: player.keeping },
    ];
    const hasAnyAttribute = attributes.some((a) => a.value != null);
    return (_jsxs("div", { children: [_jsxs(Box, { sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }, children: [_jsx(Typography, { variant: "h5", gutterBottom: true, children: "Player Bio" }), canModify && !player.externalUser && (_jsx(IconButton, { "aria-label": "edit", component: Link, to: `/players/${player.id}/edit/`, children: _jsx(EditIcon, {}) }))] }), _jsx(Divider, { sx: { marginBottom: 2 } }), _jsxs(Grid, { container: true, spacing: 3, children: [_jsxs(Grid, { item: true, xs: 6, children: [_jsx(Typography, { variant: "subtitle2", color: "textSecondary", children: "Preferred Foot" }), _jsx(Typography, { children: player.foot || "-" })] }), _jsxs(Grid, { item: true, xs: 6, children: [_jsx(Typography, { variant: "subtitle2", color: "textSecondary", children: "Primary Position" }), _jsx(Typography, { children: player.positionOne || "-" })] }), _jsxs(Grid, { item: true, xs: 6, children: [_jsx(Typography, { variant: "subtitle2", color: "textSecondary", children: "Secondary Position" }), _jsx(Typography, { children: player.positionTwo || "-" })] })] }), _jsx(Divider, { sx: { my: 2 } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "Attributes" }), hasAnyAttribute ? (_jsx(Stack, { spacing: 1.5, children: attributes.map((attribute) => {
                    if (attribute.value == null)
                        return null;
                    const color = getColorForValue(attribute.value);
                    return (_jsxs(Box, { children: [_jsxs(Box, { sx: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 0.5,
                                }, children: [_jsx(Typography, { variant: "body2", children: attribute.label }), _jsx(Typography, { variant: "body2", fontWeight: 700, children: attribute.value })] }), _jsx(LinearProgress, { variant: "determinate", value: attribute.value, "aria-label": `${attribute.label} ${attribute.value}`, sx: {
                                    height: 8,
                                    borderRadius: 4,
                                    bgcolor: "grey.200",
                                    "& .MuiLinearProgress-bar": {
                                        borderRadius: 4,
                                        bgcolor: color,
                                    },
                                } })] }, attribute.label));
                }) })) : (_jsx(Card, { variant: "outlined", sx: { bgcolor: "grey.50" }, children: _jsxs(CardContent, { sx: { textAlign: "center", py: 3, "&:last-child": { pb: 3 } }, children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: "No attributes set yet." }), canModify && !player.externalUser && (_jsx(Typography, { variant: "body2", color: "primary", component: Link, to: `/players/${player.id}/edit/`, sx: { textDecoration: "none", mt: 1, display: "block" }, children: "Rate your skills" }))] }) }))] }));
};
